@if ((breadcrumbs$ | async)?.length !== 0 || isNews()) {
  <sl-grid backgroundColor="var(--color-grey-200)"
    [sidePadding]="responsivePadding" [totalColumns]="responsiveColumns">
    <sl-column [startColumn]="1" [endColumn]="responsiveEndColumn">
      <nav aria-label="Navegación secundaria">
        <ul class="breadcrumb-nav">
          @if ((breadcrumbs$ | async)?.length !== 0 || isNews()) {
            <li class="breadcrumb">
              <app-link text="Home" link="/home" [ariaLabel]="'Go to Homepage'" [variant]="'li-body-20'"></app-link>
              <span class="material-symbols-outlined" aria-hidden="true">arrow_forward_ios</span>
            </li>
            } @if (isNews()) {
            <li class="breadcrumb">
              @if ((breadcrumbs$ | async)?.length === 0) {
                <span aria-current="page"><sl-typography variant="li-body-20" weight="regular" color="var(--color-neutral-55)"
                [text]="'Noticias'"></sl-typography></span>
              } @else {
                <app-link text="Noticias" link="/news" [ariaLabel]="'News page'" [variant]="'li-body-20'"></app-link>
                <span class="material-symbols-outlined" aria-hidden="true">arrow_forward_ios</span>
              }
            </li>
          }
          @for (breadcrumb of breadcrumbs$ | async; track breadcrumb; let last = $last) {
            @if (breadcrumb.url !== '/home' && breadcrumb.url !== '/login') {
              <li class="breadcrumb">
                @if (last) {
                  <span aria-current="page"><sl-typography variant="li-body-20" weight="regular"
                  color="var(--color-neutral-55)" [text]="breadcrumb.label"></sl-typography></span>
                } @else {
                  <app-link [text]="breadcrumb.label" [link]="breadcrumb.url" [ariaLabel]="breadcrumb.label"
                  [variant]="'li-body-20'"></app-link>
                }
              </li>
            }
          }
        </ul>
      </nav>
    </sl-column>
  </sl-grid>
}